package org.moxultimate.topwithmox.wallpaper.ui

import androidx.compose.runtime.Immutable
import org.moxultimate.topwithmox.wallpaper.data.WallpaperResponse

@Immutable
sealed class WallpaperState {
    data object Loading : WallpaperState()
    data class Error(val error: String, val statusCode: Int = 0) : WallpaperState()
    data class Success(
        val wallpaperList: List<WallpaperResponse>,
        val typeList: List<String>,
        val hasMore: Boolean = true,
    ) : WallpaperState()
}